import {
  Box,
  Divider,
  Stack,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';

interface IFourSegment {
  steps: string[];
}

export const FourSegment = ({ steps }: IFourSegment) => {
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.MedicationsAndPrescriptionsLobby,
  );
  const isDesktop = useIsDesktop();

  return (
    <Stack
      sx={{
        borderRadius: '16px',
        boxShadow: '-2px -2px 12px 0px rgba(8, 30, 84, 0.04)',
        border: '1px solid',
        borderColor: 'primary.shade_100',
        m: '52px 0',
      }}
    >
      <Box
        sx={{
          borderRadius: '16px',
          backgroundColor: 'white',
          p: isDesktop ? '18px 24px' : '20px 16px 22px',
          zIndex: 1,
        }}
      >
        <Typography component='h1' variant={isDesktop ? 'h5' : 'h3'}>
          {dictionary.yourRequestWillBeTreatedLikeSoDesktop}
        </Typography>
        <Divider
          aria-hidden='true'
          sx={{ borderColor: 'primary.shade_100', mt: 2, mb: 2 }}
        />
        <Stepper
          orientation='vertical'
          sx={{
            '& .MuiStepConnector-root': {
              right: '12px',
              left: 'auto',
            },
            '& .MuiStepConnector-line': {
              borderColor: 'purple2.shade_300',
            },
            '& .MuiStepConnector-lineVertical': {
              borderLeft: 'none',
              borderRight: '2px solid',
              borderColor: 'purple2.shade_300',
              borderWidth: '1px',
              position: 'relative',
              right: '12px',
              left: 'auto',
            },
            '& .MuiStep-root': {
              textAlign: 'right',
              alignItems: 'flex-start',
            },
            '& .MuiStepLabel-root': {
              alignItems: 'flex-start',
              gap: '12px',
            },
            '& .MuiStepLabel-labelContainer': {
              textAlign: 'right',
              ml: '12px',
            },
          }}
        >
          {steps.map((step, index) => (
            <Step key={step}>
              <StepLabel
                sx={{
                  '& .MuiStepLabel-labelContainer span': {
                    fontWeight: '400',
                    textAlign: 'right',
                  },
                  '& .MuiStepLabel-iconContainer': {
                    pr: 0,
                  },
                  '& .MuiStepIcon-root.Mui-active': { color: 'purple2.main' },
                  '& .MuiStepIcon-root': { color: 'purple2.main' },
                  textAlign: 'right',
                }}
                slotProps={{
                  stepIcon: {
                    sx: {
                      color: 'purple2.main',
                      fontWeight: '400',
                    },
                  },
                }}
              >
                {step}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>
    </Stack>
  );
};
